<template>
  <ProgressSpinner v-if="!regulation"/>
  <Container class="pt-6" v-if="regulation">
    <div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
      <PageHeading>{{ regulation.name ?? $route.params.regulation }}</PageHeading>
    </div>

    <div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
      <TabLayout :tabs="tabs" sticky/>
    </div>

    <router-view
        @on-save="$emit('on-save')"
        @on-delete="$emit('on-delete')"
        :regulation="regulation"
    ></router-view>
  </Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import {mapStores} from "pinia";
import Container from "@/Components/Container.vue";
import {useRegulationsStore} from "@/stores/regulations.js";


export default {
  name: "RegulationAdminView",
  components: {Container, TabLayout, PageHeading},
  data() {
    return {
      regulation: undefined,
    }
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  watch: {
    '$route.params.regulation': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.regulation === 'NEW') {
            this.regulation = {};
          } else {
            this.regulation = await this.regulationsStore.showRegulation(this.$route.params.regulation);
          }
        } else {
          this.regulation = undefined;
        }
      },
      immediate: true,
    }
  },
  computed: {
    ...mapStores(useRegulationsStore),
    tabs() {
      return [
        {
          label: this.$t('pages.admin.regulations.regulations.regulation.regulation_admin_view.properties'),
          current: this.$route.name === 'admin.regulations.regulation',
          to: {name: 'admin.regulations.regulation', params: this.$route.params}
        },
        {
          label: this.$t('pages.admin.regulations.regulations.regulation.regulation_admin_view.history'),
          current: this.$route.name === 'admin.regulations.regulation.history',
          to: {name: 'admin.regulations.regulation.history', params: this.$route.params}
        },
      ]
    }
  },
}
</script>
